import '../../css/sections/Navigation.css';

function Navigation({ darkLogo }) {
    return (
        <nav>
            <div>
                <a href="#home" aria-label="Go to home page">
                    <img
                        src={darkLogo ? "/sb_logo_dark.svg" : "/sb_logo.svg"}
                        alt="Samuel Banczik Logo"
                        style={{ transition: 'opacity 0.3s ease' }}
                    />
                </a>
            </div>
            <div className='navbar'>
                <ul>
                    <li data-dark={darkLogo}>
                        <a
                            href="#home"
                            style={{
                                color: darkLogo ? 'var(--black)' : 'var(--white)',
                                transition: 'color 0.3s ease'
                            }}
                        >
                            HOME
                        </a>
                    </li>
                    <li data-dark={darkLogo}>
                        <a 
                            href="#works"
                            style={{ 
                                color: darkLogo ? 'var(--black)' : 'var(--white)',
                                transition: 'color 0.3s ease'
                            }}
                        >
                            WORKS
                        </a>
                    </li>
                    <li data-dark={darkLogo}>
                        <a 
                            href="#contact"
                            style={{ 
                                color: darkLogo ? 'var(--black)' : 'var(--white)',
                                transition: 'color 0.3s ease'
                            }}
                        >
                            CONTACT
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Navigation;
